import {
  GET_MY_FUNDS_DETAIL_INIT,
  GET_MY_FUNDS_DETAIL_SUCCESS,
  GET_MY_FUNDS_DETAIL_FAILED,
  UPLOAD_TEAR_SHEET_INIT,
  UPLOAD_TEAR_SHEET_SUCCESS,
  UPLOAD_TEAR_SHEET_FAILED,
  INVESTORS_LIST_INIT,
  INVESTORS_LIST_SUCCESS,
  INVESTORS_LIST_FAILED,
  UPDATE_MONTHLY_RETURN_INIT,
  UPDATE_MONTHLY_RETURN_SUCCESS,
  UPDATE_MONTHLY_RETURN_FAILED,
  SEARCH_PMRESULT_SUCCESS,
  SEARCH_PMRESULT_INIT,
  SEARCH_PMRESULT_FAILED,
  SEARCH_RPRESULT_INIT,
  SEARCH_RPRESULT_SUCCESS,
  SEARCH_RPRESULT_FAILED,
  SEARCH_REPORTRESULT_INIT,
  SEARCH_REPORTRESULT_SUCCESS,
  SEARCH_REPORTRESULT_FAILED,
  GET_FUND_BIO_USER_INIT,
  GET_FUND_BIO_USER_SUCCESS,
  GET_FUND_BIO_USER_FAILED,
} from "./constants";
import moment from 'moment';
const initialState = {
  loading: false,
  myFundDetails: [],
  tearSheetUpload: {},
  rows: null,
  monthlyReturnPerformance: [],
  riskReportMonths: [],
  riskReportByMonth: {},
  investorList: [],
  tableLoading: false,
  pmLoading:false,
  performanceMetrcisMonth : [],
  tearSheetLoading : false,
  fileDeckLoading: false,
  riskReportMonthList : [],
  reportExtractData : {},
  fundBioUsers : [],
  bioLoading : false,
};

const months = {
  1: "january",
  2: "february",
  3: "march",
  4: "april",
  5: "may",
  6: "june",
  7: "july",
  8: "august",
  9: "september",
  10: "october",
  11: "november",
  12: "december",
};

export default function fundDetail(state = initialState, action) {
  const toObject = (arr) => {
    return arr.reduce(function (acc, cur) {
      acc[months[cur.month]] = cur.monthlyReturn?.toFixed(2);
      return acc;
    }, {});
  };

  switch (action.type) {
    case GET_MY_FUNDS_DETAIL_INIT:
      return {
        ...state,
        loading: true,
        myFundDetails: {},
        monthlyReturnPerformance: [],
        reportExtractData : {}
      };
    case GET_MY_FUNDS_DETAIL_SUCCESS:
      const { monthlyReturnPerformances } = action.payload;
      let performance = [];
      monthlyReturnPerformances.map((p) => {
        return performance.push({
          // averageMonthlyReturn: p?.monthsData
          //   ?.map((item) => item?.monthlyAverage)[0]
          //   .toFixed(2),
          year: p.year,
          ytd : p.ytd,
          ...toObject(p.monthsData),
        });
      });

      return {
        ...state,
        loading: false,
        myFundDetails: { ...action.payload },
        monthlyReturnPerformance: performance,
      };
    case GET_MY_FUNDS_DETAIL_FAILED:
      return { ...state, loading: false };
    case UPLOAD_TEAR_SHEET_INIT:
      return { ...state, tearSheetLoading: true };
    case UPLOAD_TEAR_SHEET_SUCCESS:
      let monthtear = [...state.monthlyReturnPerformance];
      let yearExists = false;

      let updattedTearSheet = monthtear.reduce((acc, item, i) => {
        let uploadMonth = moment(action.payload.month);
        let monthKey = uploadMonth.format("MMMM").toLowerCase();
        if (item.year === uploadMonth.year()) {
          yearExists = true;
          if (monthKey in item) {
            item[monthKey] = action.payload.monthlyReturn.toString();
          } else {
            item[monthKey] = action.payload.monthlyReturn.toString();
          }
        }
        return [...acc, item];
      }, []);

      if (!yearExists) {
        updattedTearSheet = [
          ...updattedTearSheet,
          {
            year: moment(action.payload.month).year(),
            [moment(action.payload.month).format("MMMM").toLowerCase()]:
              action.payload.monthlyReturn,
          },
        ];
      }

      return {
        ...state,
        tearSheetLoading: false,
        monthlyReturnPerformances: updattedTearSheet,
      };
    case UPLOAD_TEAR_SHEET_FAILED:
      return { ...state, tearSheetLoading: false };
    case INVESTORS_LIST_INIT:
      return { ...state, loading: true };
    case INVESTORS_LIST_SUCCESS:
      return { ...state, loading: false, investorList: action.payload };
    case INVESTORS_LIST_FAILED:
      return { ...state, loading: false };
    case UPDATE_MONTHLY_RETURN_INIT:
      return { ...state, tableLoading: true };
    case UPDATE_MONTHLY_RETURN_SUCCESS:
      return { ...state, tableLoading: false };
    case UPDATE_MONTHLY_RETURN_FAILED:
      return { ...state, tableLoading: false };
    case SEARCH_PMRESULT_INIT:
      return { ...state, pmLoading:true };
    case SEARCH_PMRESULT_SUCCESS:
      return { ...state, performanceMetrcisMonth: action.payload,pmLoading:false };
    case SEARCH_PMRESULT_FAILED:
      return { ...state ,pmLoading:false};
      
    case SEARCH_RPRESULT_INIT:
      return { ...state, pmLoading:true };
    case SEARCH_RPRESULT_SUCCESS:
      return { ...state, riskReportMonthList: action.payload,pmLoading:false };
    case SEARCH_RPRESULT_FAILED:
      return { ...state ,pmLoading:false};
    case SEARCH_REPORTRESULT_INIT:
      return { ...state, pmLoading:true };
    case SEARCH_REPORTRESULT_SUCCESS:
      return { ...state, reportExtractData: action.payload,pmLoading:false };
    case SEARCH_REPORTRESULT_FAILED:
      return { ...state ,pmLoading:false};
    case GET_FUND_BIO_USER_INIT:
      return { ...state, bioLoading: true };
    case GET_FUND_BIO_USER_SUCCESS:
      return {
        ...state,
        fundBioUsers: action.payload,
        bioLoading: false,
      };
    case GET_FUND_BIO_USER_FAILED:
      return { ...state, bioLoading: false };
    default:
      return state;
  }
}
